import { useState } from 'react';

const faqs = [
  {
    q: 'Quel est le délai d\'intervention de DF PRO dans Paris 15 ?',
    a: 'DF PRO intervient dans tout le 15ᵉ arrondissement sous 24 à 48h après votre appel. Pour les urgences (fenêtre qui ne ferme plus, volet bloqué en position ouverte), nous faisons notre maximum pour nous déplacer le jour même. Nos techniciens salariés sont basés dans le 15ᵉ, ce qui nous permet une réactivité optimale dans tous les quartiers : Vaugirard, Grenelle, Javel, Beaugrenelle, Convention, etc.',
  },
  {
    q: 'Quels sont vos tarifs pour une réparation de fenêtre ?',
    a: 'Nos tarifs varient selon la nature de la panne et les pièces à remplacer. Nous pratiquons le prix fixe après diagnostic : nous nous déplaçons, analysons le problème, et vous remettons un devis détaillé et gratuit avant toute intervention. Pour vous donner un ordre d\'idée, le changement d\'une poignée ou d\'une crémone se situe généralement entre 80€ et 200€, pièce et main-d\'œuvre comprises.',
  },
  {
    q: 'Intervenez-vous sur toutes les marques de fenêtres ?',
    a: 'Oui, absolument. Nos techniciens sont formés pour intervenir sur l\'ensemble des fabricants : marques françaises et européennes de quincaillerie (Ferco, Roto, Maco, Winkhaus, Siegenia, etc.), motorisations Somfy, Bubendorff, Profalux pour les volets roulants, et tous les grands fabricants de menuiseries PVC, aluminium et bois.',
  },
  {
    q: 'Le devis est-il vraiment gratuit et sans engagement ?',
    a: 'Oui, le devis est entièrement gratuit et sans aucun engagement de votre part. Nous nous déplaçons à votre domicile dans le 15ᵉ, diagnostiquons la panne, et vous remettons un devis précis. Vous êtes libre de l\'accepter ou non. Si vous refusez, le déplacement reste gratuit.',
  },
  {
    q: 'Proposez-vous une garantie sur vos réparations ?',
    a: 'Toutes nos interventions sont garanties. La garantie couvre les pièces remplacées et la main-d\'œuvre. En cas de problème après notre passage, nous revenons sans frais supplémentaires. DF PRO est une société assurée en responsabilité civile professionnelle.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-[#e6f7f5]">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-brand-dark mb-3 font-heading">Questions fréquentes</h2>
          <p className="text-sm md:text-base text-brand-text/60">Tout ce que vous devez savoir sur nos services de réparation</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-2xl border border-brand-mint/60 overflow-hidden shadow-sm">
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left hover:bg-brand-mint/30 transition-colors"
                aria-expanded={openIndex === idx}
              >
                <span className="font-heading font-bold text-brand-dark text-sm md:text-base pr-4">{faq.q}</span>
                <i className={`ri-${openIndex === idx ? 'subtract' : 'add'}-line text-brand-accent text-lg flex-shrink-0 transition-transform duration-300`}></i>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-4 md:px-6 md:pb-5 animate-fade-in">
                  <p className="text-brand-text/70 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}